import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Form = loadable(() => import('./Form'), {});
